import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      [theme.breakpoints.down('sm')]: {
        marginTop: 10,
      },
      [theme.breakpoints.down('xs')]: {
        marginTop: 5,
      },
      marginTop: 15,
      padding: '0px!important',
    },
    logo: {
      width: 60,
    },
    iconLeft: {
      width: 25,
      marginLeft: 10,
      marginRight: 2,
    },
    iconUser: {
      width: 25,
    },
    textComponentLeft: {
      display: 'flex',
      margin: '0px!important',
      fontSize: 12,
      textAlign: 'left',
      cursor: 'pointer',
      alignItems: 'center',
    },
    textComponentRight: {
      display: 'flex',
      margin: '0px!important',
      fontSize: 13,
      cursor: 'pointer',
      alignItems: 'center',
    },

    gridInput: {
      left: '0px',
      top: 5,
      position: 'absolute',
      backgroundColor: '#fff',
    },
    inputText: {
      margin: '5px 0!important',
      padding: '6px 35px!important',
      width: '97%',
      left: '5px',
      top: 5,
      zIndex: 15,
      position: 'absolute',
      backgroundColor: '#fff',
    },
    icon: {
      width: 20,
      height: 20,
      marginLeft: 10,
      zIndex: 16,
      left: 0,
      top: 20,
      position: 'absolute',
    },

    titleModal: {
      margin: '10px 0 0px 0!important',
      width: '100%',
      justifyContent: 'center',
      textAlign: 'center',
      textTransform: 'uppercase',
    },
    textModal: {
      textAlign: 'center',
      marginBottom: '15px!important',
      margin: '0px 0!important',
      color: '#a8a8a8',
    },

    textBtnKeepShopping: {
      color: '#292d32',
      margin: '0px 0!important',
    },

    btnSubmit: {
      margin: '10px 0!important',
      textTransform: 'uppercase',
      backgroundColor: '#a51713!important',
      width: '100%',
      borderRadius: '10px!important',
    },
  }),
);

export default useStyles;
